/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { CircularProgress } from "@mui/material";
import { formatBytes } from "utils/format-bytes";

const ImageUploadItem = (props) => {
    
    // const theme = useTheme()
    const {
        file,
        refs,
        onLoad,
        index,
        uploading = true,
        progress = 50
    } = props || {};
    
    return (
        <Fragment>
            <div className='image-upload-row' key={file.name}>
                <div className='image-upload-item'>
                    <div className='thumb-inner-style'>
                        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                        <img
                            src={file.preview}
                            ref={(ref) => refs.current[index] = ref}
                            className='thumbnail'
                            alt={file.name}
                            // Revoke data uri after image is loaded
                            onLoad={() => onLoad(file,index)}
                        />
                    </div>
                </div>
                <div>
                    <div>{file.name}</div>
                    <div>Size: {formatBytes(file.size)}</div>
                    <div>Dimensions: {file.width}x{file.height}</div>
                </div>
                <div 
                    style={{
                        height: "100%", width: "64px", marginLeft: "auto",
                        display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                >
                    {uploading &&
                        <CircularProgress
                            variant="determinate"
                            value={progress}
                        />
                    }
                </div>
            </div>
    
        </Fragment>
    );
};
ImageUploadItem.displayName = "ImageUploadItem";
export { ImageUploadItem };
